export enum ProductMutationTypes {
    SET_LOADING_STATUS = 'SET_LOADING_STATUS',
    SET_PRODUCTS = 'SET_PRODUCTS',
    APPEND_PRODUCTS = 'APPEND_PRODUCTS',
    SET_PAGER = 'SET_PAGER',
    SET_SORT = 'SET_SORT'
}